export default {
  data() {
    return {
      perPageOptions: [
        {
          label: '10',
          value: 10,
        },
        {
          label: '25',
          value: 25,
        },
        {
          label: '50',
          value: 50,
        },
        {
          label: '100',
          value: 100,
        },
      ],
      page: 1,
      perPage: 10,
      lastPage: null,
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      },
    };
  },
  methods: {
    onPaginationData(data) {
      // Save pagination state from response object.
      this.perPage = data.meta.pagination.perPage;
      this.lastPage = data.meta.pagination.total;
      this.preferences.perPage = this.perPage;

      // Adjust pagination data to fit vuetable.
      const paginationData = {
        current_page: this.page,
        last_page: this.lastPage,
        perPage: this.perPage,
      };

      // Set adjusted pagination data in pagination refs.
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      // Deal with pagination using 'next' and 'prev' strings on page change
      if (page === 'prev') {
        page = this.page > 1 ? this.page - 1 : 0;
      } else if (page === 'next') {
        page = this.page + 1;
      }
      // Prevent request for page number higher than last page or lower than 1.
      if (page > this.lastPage || page < 1) {
        return;
      }
      this.page = page;
      this.$nextTick(() => {
        this.$refs.vuetable && this.$refs.vuetable.refresh();
      });
    },
  },
  watch: {
    perPage() {
      // When perPage is changed, go to page 1.
      this.page = 1;

      // Only request new data when selected perPage is different from preferences.
      if (this.preferences.perPage !== this.perPage) {
        // Reload the table with adjusted number of rows.
        this.$refs.vuetable && this.$nextTick(() => this.$refs.vuetable.refresh());
      }
    },
  },
};
